"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _a, _b;
Object.defineProperty(exports, "__esModule", { value: true });
exports.ToastType = void 0;
var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
var react_1 = require("@emotion/react");
var recoil_1 = require("recoil");
var Styled = __importStar(require("./Toast.styled"));
var success_24_svg_1 = __importDefault(require("@/assets/svg/success-24.svg"));
var error_24_svg_1 = __importDefault(require("@/assets/svg/error-24.svg"));
var close_red_32_svg_1 = __importDefault(require("@/assets/svg/close-red-32.svg"));
var close_green_32_svg_1 = __importDefault(require("@/assets/svg/close-green-32.svg"));
var store_1 = require("@/store");
var hooks_1 = require("@/hooks");
var components_1 = require("@/components");
exports.ToastType = {
    success: 'success',
    error: 'error',
};
var icon = (_a = {},
    _a[exports.ToastType.success] = (0, jsx_runtime_1.jsx)(success_24_svg_1.default, {}, void 0),
    _a[exports.ToastType.error] = (0, jsx_runtime_1.jsx)(error_24_svg_1.default, {}, void 0),
    _a);
var closeButton = (_b = {},
    _b[exports.ToastType.success] = (0, jsx_runtime_1.jsx)(close_green_32_svg_1.default, {}, void 0),
    _b[exports.ToastType.error] = (0, jsx_runtime_1.jsx)(close_red_32_svg_1.default, {}, void 0),
    _b);
var Toast = function () {
    var toast = (0, recoil_1.useRecoilValue)(store_1.$toast);
    var handleRemoveToast = (0, hooks_1.useToast)().handleRemoveToast;
    if (!toast) {
        return null;
    }
    var type = toast.type, message = toast.message;
    return ((0, jsx_runtime_1.jsx)(components_1.Portal, { children: (0, jsx_runtime_1.jsxs)(Styled.Toast, __assign({ type: type }, { children: [icon[type], (0, jsx_runtime_1.jsx)("span", { children: message }, void 0), (0, jsx_runtime_1.jsx)("button", __assign({ type: "button", onClick: handleRemoveToast }, { children: closeButton[type] }), void 0)] }), void 0) }, void 0));
};
exports.default = Toast;
